var CollectionView = require('views/base/collection-view');

var ActionPlanTopicsCollectionView = CollectionView.extend({
  noWrap: false,
  autoRender: true,
  template: require('./templates/action-plan-topics-collection'),
  listSelector: '.action-plan-topics',
  itemView: require('./action-plan-topic-view'),
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      blockModel: this.model,
      autoRender: false,
      noWrap: true,
      model: model
    });
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ActionPlanTopicsCollectionView;